import { LocalStorageKeys } from '@/constants/LocalStorageKeys';
import DataDiscrepancyService from '@/services/3.6/DataDiscrepancyService';
import TheWebEnvConfigService from '@/services/TheWebEnvConfigService';
import theLocalStorageUtils from '@/utils/LocalStorageUtils';

export default {
    /**
     * Get a MLS token and save to local storage
     * @returns
     */
    async getToken(renew: boolean): Promise<string | null> {
        if (renew || !theLocalStorageUtils.hasKeyAndValue(LocalStorageKeys.mlsToken)) {
            await fetchAndSave();
        }

        const mlsToken = theLocalStorageUtils.get(LocalStorageKeys.mlsToken);
        return mlsToken;
    },
};

async function fetchAndSave(): Promise<boolean> {
    const webConfig = await TheWebEnvConfigService.getInstance().getConfigByHost();
    const service = new DataDiscrepancyService(webConfig);

    const mlsToken = await service.getMLSToken();
    if (mlsToken) {
        theLocalStorageUtils.save(LocalStorageKeys.mlsToken, mlsToken);
        //console.log('MlsTokenManager.fetchAndSave(), Saved to local storage.');
        return true;
    }

    console.log('MlsTokenManager.fetchAndSave(), Failed to get a token.');
    return false;
}
